import { render, staticRenderFns } from "./childMonitoring.vue?vue&type=template&id=fa1b2d0c"
import script from "./childMonitoring.vue?vue&type=script&lang=js"
export * from "./childMonitoring.vue?vue&type=script&lang=js"
import style0 from "./childMonitoring.vue?vue&type=style&index=0&id=fa1b2d0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports